import { action } from 'satcheljs';

export const manageSecurity = action('manageSecurity');
